import customAxios from "./axios";
import CONFIG from "../../config";

export const getAllMasterProcess = () =>
  customAxios.get(`${CONFIG.apiURL}/MasterProcesses/Process`);

export const getAllServices = () =>
  customAxios.get(`${CONFIG.apiURL}/Departments/Services`);

export const getQuotation = (payload) =>
  customAxios.post(
    `${CONFIG.apiURL}/CorporateCompanyJob/GetQuotation`,
    payload
  );

export const createJob = (formData) =>
  customAxios.post(
    `${CONFIG.apiURL}/CorporateCompanyJob/CreateJob`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const getAllJobs = ({ departmentId, processId, masterProcessId, companyName, page, id, jobStatus, startDate = "", endDate = "" }) =>
  customAxios.get(`${CONFIG.apiURL}/CorporateCompanyJob/GetAllJobs?Department=${departmentId}
  &Process=${processId}&MasterProcess=${masterProcessId}&Company=${companyName}&page=${page}&id=${id}&jobStatus=${jobStatus}&startDate=${startDate}&endDate=${endDate}`);

export const getCorporateJobById = (id) =>
  customAxios.get(
    `${CONFIG.apiURL}/CorporateCompanyJob/GeJobDetail?requestId=${id}`
  );

export const downloadDocument = (userId, documentId) => {
  return customAxios.get(CONFIG.documentURL + `/DocumentVault/Document/Download?userId=${userId}&documentId=${documentId}`).then(res => {
    let response = res['data'];
    return response;
  });
};

export const multiDownloadDocument = (payload) => {
  return customAxios.post(CONFIG.documentURL + `/DocumentVault/Document/MultiDownload`, payload).then(res => {
    let response = res['data'];
    return response;
  });
};

export const checkoutForCorporateCompanyJob = (jobId) => {
  return customAxios.get(CONFIG.apiURL + `/CorporateCompanyJob/CheckoutForCorporateCompanyJob?requestId=${jobId}`).then(res => {
    let response = res['data'];
    return response;
  });
};

export const getIndividual = (id) => {
  return customAxios.get(CONFIG.apiURL + `/Jobs/JobDetails?jobId=${id}`).then((res) => {
    let response = res["data"];
    return response;
  });
};

export const downloadVendorDocument = (documentID) => {
  return customAxios.get(CONFIG.documentURL +`/DocumentVault/Document/Download?userId=2&documentId=${documentID}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getVendorDocumentMetaData = (documentIds) => {
  return customAxios.get(CONFIG.documentURL +`/DocumentVault/ReceiptDocument/GetMetadata?userId=2&documentIds=${documentIds}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAdditionalPaymentDetail = (jobID) => {
  return customAxios.get(CONFIG.apiURL + `/AdditionalPaymentRequests/GetByJob?jobID=${jobID}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getDocumentMetaData = (userID, documentIds) => {
  return customAxios.get(CONFIG.documentURL +`/DocumentVault/Document/GetMetadata?userId=2&documentIds=${documentIds}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getTransactionSummaryDetail = (payload) => {
  return customAxios.get(CONFIG.apiURL + `/Transactions/SummaryDetails?jobId=${payload}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const downloadZipDocument = (payload) => {
  return customAxios.post(CONFIG.documentURL + `/DocumentVault/Document/MultiDownload`, payload).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getMetadata = (payload) => {
  return customAxios.get(CONFIG.documentURL + `/DocumentVault/ReceiptDocument/GetMetadata?documentIds=${payload}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const corporateCompanyJobSaveAsDraft = (payload) =>
  customAxios.post(`${CONFIG.apiURL}/CorporateCompanyJob/SaveAsDraft`,payload,{ 
    headers: { "Content-Type": "multipart/form-data", }
  }
);


export const biometricRecieptDownalod = (applicationNo, jobId) => {
  return customAxios.get(
    `${CONFIG.apiURL}/BiometricAppointment/GenerateBiometricReceipt`,
    { 
      params: {
        applicationNo,
        jobId
      },
    }
  ).then(res => res.data);
}

export const getAllBiometricCenters = () => {
  return customAxios.get(`${CONFIG.apiURL}/BiometricAppointment/GetBiometricCenters`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const corporateJobStatusUpdate = (jobId, status) => {
  return customAxios.put(CONFIG.apiURL + `/CorporateCompanyJob/UpdateJobStatus?jobId=${jobId}&status=${status}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getJobStatistics = (startDate, endDate) => {
  return customAxios.get(CONFIG.apiURL + `/CorporateCompanyJob/GetDashboardData?startDate=${startDate}&endDate=${endDate}`).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getExportJobs = (startDate, endDate, jobStatus="") => {
  return customAxios.get(CONFIG.apiURL + `/CorporateCompanyJob/ExportCsv?startDate=${startDate}&endDate=${endDate}&jobStatus=${jobStatus}`).then((res) => {
    let response = res["data"];
    return response;
  });
};

export const sendReportEmail = (email, payload) => {
  return customAxios.post(CONFIG.apiURL + `/CorporateCompanyJob/SendReportByMail?email=${email}`, payload).then((res) => {
      let response = res["data"];
      return response;
    });
};

export const downloadPaymentVoucher = (jobId) => {
  return customAxios.get(CONFIG.apiURL + `/Payments/DownloadCorporateCompanyJobPaymentVoucher?id=${jobId}`, { responseType: 'blob' }).then((res) => {
      let response = res["data"];
      return response;
    });
};

